import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { getVisionMission, updateVisionMission } from '../../api';
import { toast } from 'sonner';
import { Save } from 'lucide-react';

const VisionMission = () => {
  const [formData, setFormData] = useState({
    vision: { title: 'Vision', description: '' },
    mission: { title: 'Mission', description: '' }
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    fetchVisionMission();
  }, []);

  const fetchVisionMission = async () => {
    setIsLoading(true);
    try {
      const response = await getVisionMission();
      setFormData(response.data);
    } catch (error) {
      toast.error('Failed to load vision and mission');
    }
    setIsLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    try {
      await updateVisionMission(formData);
      toast.success('Vision and mission updated successfully!');
    } catch (error) {
      toast.error('Failed to update vision and mission');
    }

    setIsSaving(false);
  };

  if (isLoading) {
    return <div className="flex justify-center items-center h-64">Loading...</div>;
  }

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Vision & Mission</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        <Card>
          <CardHeader>
            <CardTitle>Vision</CardTitle>
          </CardHeader>
          <CardContent>
            <Textarea
              value={formData.vision.description}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  vision: { ...formData.vision, description: e.target.value }
                })
              }
              rows={5}
              required
            />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Mission</CardTitle>
          </CardHeader>
          <CardContent>
            <Textarea
              value={formData.mission.description}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  mission: { ...formData.mission, description: e.target.value }
                })
              }
              rows={5}
              required
            />
          </CardContent>
        </Card>

        <Button
          type="submit"
          className="bg-gradient-to-r from-teal-500 to-cyan-600 hover:from-teal-600 hover:to-cyan-700"
          disabled={isSaving}
        >
          {isSaving ? (
            <span className="flex items-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              Saving...
            </span>
          ) : (
            <span className="flex items-center">
              <Save className="w-4 h-4 mr-2" />
              Save Changes
            </span>
          )}
        </Button>
      </form>
    </div>
  );
};

export default VisionMission;
